import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReserveRequestDto as RequestDto,
  ReserveResponseDto as ResponseDto,
} from "../../api/instanceReservation/reserve/dtos";
import { Api } from "../../api";
import { Activity, ActivityAvailability, PersonType } from "../../models";
import parse from "date-fns/parse";
import format from "date-fns/format";
import { PersonTypesEndpoint } from "../personTypes";

type CallParams = {
  activity: Activity;
  availability: ActivityAvailability;
  personTypes: (PersonType & { quantity: number })[];
};
type Data = string[];

export const reserve = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data,
  CallParams
>(
  "RESERVE_ACTIVITY",
  Api.instanceReservation.reserve,
  ({ data: { data } }) => data,
  ({ activity, availability, personTypes: selectedPersonTypes }) => {
    const { slots } = availability.reservationData;
    const allPersonTypes = PersonTypesEndpoint.list.store.getState();

    let peopleToAllocate = selectedPersonTypes.reduce(
      (acc, { quantity, id }) => {
        const personTypeRecord = allPersonTypes.data?.data.find(
          (record) => record.id === id
        );
        // check if person type is allocatable at this activity
        if (personTypeRecord?.activityIdToAllocatableMap?.[activity.id]) {
          return acc + quantity;
        }
        return acc;
      },
      0
    );

    return {
      instances: slots.map((slot) => {
        const {
          slot_id,
          instance_start_time,
          instance_end_time,
          capacity,
        } = slot;

        const peopleAmount = Math.min(peopleToAllocate, capacity);

        peopleToAllocate -= peopleAmount;

        const start = parse(
          instance_start_time,
          "yyyy-MM-dd HH:mm:ss",
          new Date()
        );
        const end = parse(instance_end_time, "yyyy-MM-dd HH:mm:ss", new Date());

        return {
          activity_id: activity.id,
          slot_id: slot_id,
          start_date: format(start, "dd-MM-yyyy HH:mm"),
          end_date: format(end, "dd-MM-yyyy HH:mm"),
          people_amount: peopleAmount,
        };
      }),
    };
  }
);
